import * as React from 'react';

import { Typography } from 'app/components/common/typography';

import { QuantityButton } from './quantity-button/quantity-button';

import styles from './quantity-input.module.scss';

export interface Props {
    disabled?: boolean;
    value: number;
    onChange: (value: number) => void;
    max?: number;
    min?: number;
}

class QuantityInput extends React.Component<Props> {
    public static readonly defaultProps: Partial<Props> = {
        min: 0,
    };

    public render(): React.ReactNode {
        const { value, disabled, max, min } = this.props;

        const isMinusButtonDisabled = disabled || value === min;
        const isPlusButtonDisabled = disabled || value === max;

        return (
            <div className={styles.quantityInput}>
                <QuantityButton iconType="minus-circle" disabled={isMinusButtonDisabled} onClick={this.handleMinus} />
                <Typography className={styles.value} variant="subtitle1" component="span">
                    {value}
                </Typography>
                <QuantityButton iconType="plus-circle" disabled={isPlusButtonDisabled} onClick={this.handlePlus} />
            </div>
        );
    }

    private handlePlus = (): void => {
        const { value, onChange, max } = this.props;

        if (max && value >= max) {
            return;
        }

        onChange(value + 1);
    };

    private handleMinus = (): void => {
        const { value, onChange, min } = this.props;

        if (min === undefined || value > min) {
            onChange(value - 1);
        }
    };
}

export { QuantityInput };
